import React from 'react';
import { useTour } from './TourProvider';
import { useUserProfile } from '../../services/python-api/authHooks.js';
import { useLocation } from 'react-router-dom';

const TourButton = () => {
  const { startTour } = useTour();
  const { data: userProfile } = useUserProfile();
  const location = useLocation();

  const tourSteps = [
    {
      title: "Home Dashboard",
      description: "This is your main dashboard where you can see shipment overview, active shipments, and recent payments.",
      selector: ".flex-1.bg-\\[\\#FAFBFC\\]",
      route: "/home",
      tooltipPosition: { left: '50px', top: '50%', transform: 'translateY(-50%)' }
    },
    {
      title: "Chat List",
      description: "Here you can see all your previous conversations and shipment requests.",
      selector: ".w-\\[40\\%\\].bg-white.border-r",
      route: "/chats/new",
      tooltipPosition: { left: '320px', top: '200px' }
    },
    {
      title: "New Chat Button",
      description: "Click here to start a new shipment conversation with our AI assistant.",
      selector: "[data-tour='new-chat-button']",
      route: "/chats/new",
      tooltipPosition: { left: '50px', top: '200px' }
    },
    {
      title: "Conversation Area",
      description: "This is where you'll chat with our AI assistant about your shipment needs.",
      selector: "[data-tour='conversation-area']",
      route: "/chats/new",
      tooltipPosition: { right: '50px', top: '200px' }
    }
  ];

  const handleStartTour = () => {
    startTour(tourSteps);
  };

  // Only show tour button on dashboard page
  const isDashboardPage = location.pathname === '/home';
  
  // Don't show tour button if user has completed onboarding or not on dashboard
  if (userProfile?.completed_onboarding || !isDashboardPage) {
    return null;
  }

  return (
    <button
      onClick={handleStartTour}
      className="fixed bottom-4 right-4 bg-blue-600 text-white p-3 rounded-full shadow-lg hover:bg-blue-700 transition-colors z-50"
      title="Take a tour"
    >
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="12" r="10"/>
        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
        <path d="M12 17h.01"/>
      </svg>
    </button>
  );
};

export default TourButton;